import React from "react";
import Button from "@mui/material/Button";
import {useState} from "react";
import {useDispatch} from "react-redux";
import DialogContentText from "@mui/material/DialogContentText";
import {addRole} from "../../index";
import {setModal} from "../../../../Common/App";
import {CardActions, CardContent, CardHeader, TextField} from "@mui/material";
import {DialogCard} from "../../../../../Components";
export const AddRoleModal = () => {

    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState({});
    // eslint-disable-next-line no-unused-vars -- setResponse reserved for API error display
    const [response, setResponse] = useState({});
    const [, setErrors] = useState({});
    const [, setMessage] = useState("");
    const [, setStatus] = useState("info");

    const handleChange = (e) => {
        setData(data => ({
            ...data,
            [e.target.name] :e.target.value,
        }));
    }

    const handleSubmit = async () => {
        setIsLoading(true);
        await addRole({dispatch, data}).then((res)=>{
            setIsLoading(false);
            if(res['success']){
                dispatch(setModal({component:null, open:false}));
            }
            setErrors(res.errors)
            setMessage(res.message)
            setStatus(res.status)
        });
    };

    return(
        <DialogCard>
            <CardHeader title={"Add Role"} />
            <CardContent>
                <DialogContentText>
                    <TextField
                        fullWidth
                        label="Role Name"
                        name="role_name"
                        onChange={(e) => handleChange(e)}
                        variant="outlined"
                        helperText={response?.error?.data?.errors?.role_name}
                    />
                </DialogContentText>
            </CardContent>
            <CardActions>
                <Button onClick={() => dispatch(setModal({component:null, open:false}))}>Cancel</Button>
                <Button disabled={isLoading} variant="contained" color={'primary'} onClick={ handleSubmit }>Add Role</Button>
            </CardActions>
        </DialogCard>
    )
}